/**
 * @generated SignedSource<<3745c3ba6461b40ac3a52005defe8959>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PolicyCollectionPicker_policyCollections$data = {
  readonly policyCollections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly roleAssignmentTarget: any;
        readonly userPermissions: ReadonlyArray<Permission>;
        readonly uuid: any;
      };
    }>;
  };
  readonly " $fragmentType": "PolicyCollectionPicker_policyCollections";
};
export type PolicyCollectionPicker_policyCollections$key = {
  readonly " $data"?: PolicyCollectionPicker_policyCollections$data;
  readonly " $fragmentSpreads": FragmentRefs<"PolicyCollectionPicker_policyCollections">;
};

import PolicyCollectionPickerRefetchQuery_graphql from './PolicyCollectionPickerRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "policyCollectionFilterElement"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": PolicyCollectionPickerRefetchQuery_graphql
    }
  },
  "name": "PolicyCollectionPicker_policyCollections",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "policyCollectionFilterElement"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "PolicyCollectionConnection",
      "kind": "LinkedField",
      "name": "policyCollections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PolicyCollectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PolicyCollection",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userPermissions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleAssignmentTarget",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "50103250137edd47f8f134adb50215f0";

export default node;
